module.exports = "/_next/static/images/hezuohuoban-zhuangshi-b89181a18e6c92f0125aa7d3b71cc088.png";